import React from 'react';
import ModalProvider from '@lwtears/lwt-common-frontend/lib/Modal/providers/ModalProvider';
import { AlertProvider } from './AlertProvider';
import { FullScreenProvider } from './FullScreenProvider';
import { ResourcesProvider } from './ResourcesProvider';
import { ZoomProvider } from './ZoomProvider';
import { ThemeProvider } from './ThemeProvider';
import { DraggableModalTitle } from 'components/@common/Modals/DraggableModalTitle';
import store from '../store';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

export const BaseAppProviders = ({
  children
}: {
  children: React.ReactElement;
}): React.ReactElement => {
  const ModalProvider1 = ModalProvider as any;
  return (
    <ReduxProvider store={store}>
      <BrowserRouter>
        <ThemeProvider>
          <ZoomProvider>
            <AlertProvider>
              <ResourcesProvider>
                <FullScreenProvider>
                  <ModalProvider1 Title={DraggableModalTitle as any}>{children}</ModalProvider1>
                </FullScreenProvider>
              </ResourcesProvider>
            </AlertProvider>
          </ZoomProvider>
        </ThemeProvider>
      </BrowserRouter>
    </ReduxProvider>
  );
};
